import classNames from '@/utils/classNames';
import type { ButtonHTMLAttributes, FC } from 'react';
import styles from './ButtonLink.module.css';

export const ButtonLink: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({ className, children, ...rest }) => (
    <button className={classNames(styles.buttonLink, className)} {...rest}>
        {children}
    </button>
);
